module.exports = __webpack_public_path__ + "ecbe6f8e52568d7458730555132994a4.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-84.png
// module id = 149
// module chunks = 0